<template>
  <div class="hot-artcle">
    <div class="title">热门文章</div>
    <template v-if="hotList.length > 0">
      <div
        class="hot-item"
        @click="handleDetail(item.id)"
        v-for="item in hotList"
        :key="item.id"
      >
        <img :src="item.image" alt="" />
        <div class="headline">{{ item.title }}</div>
        <div class="time">{{ item.createDate }}</div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'hotSearch',
  components: {},
  props: {
    hotList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {

    }
  },
  computed: {},
  watch: {},
  created() {

  },
  mounted() {

  },
  methods: {
    handleDetail(id) {
      if (this.$route.path == '/artcle') {
        this.$emit('getDetail',id)
      } else {
        this.$router.push({
          path: '/artcle',
          query: {
            id,
            type: 2
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.hot-artcle {
  width: 260px;
  .title {
    background: url('../../../assets/artcle/hot-artcle.png') no-repeat 0 8px;
    background-size: 30px 24px;
    padding-left: 42px;
    font-size: 28px;
    font-weight: 500;
    color: #24232f;
    margin-bottom: 38px;
  }
  .hot-item {
    margin-bottom: 18px;
    cursor: pointer;
    img {
      width: 260px;
      height: 140px;
    }
    .headline {
      padding-left: 9px;
      font-size: 20px;
      font-weight: 500;
      color: #24232f;
      margin-top: 12px;
    }
    .time {
      padding-left: 9px;
      font-size: 12px;
      font-weight: 400;
      color: #767d8f;
      line-height: 32px;
    }
  }
}
</style>
